package com.mgacreative.hotelru.shared.ui.designsystem.components

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.KeyboardArrowUp
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

import androidx.compose.ui.draw.shadow

@Composable
fun HelpScreen() {
    val helpTopics = listOf(
        Pair(
            "Başlarken Yapılacaklar (Kurulum ve İşleyiş Rehberi)",
            "1. Otel ve Oda Kurulumu:\n• Yönetim > Otel Profili bölümünden otel temel bilgilerini kaydedin.\n• Yönetim > Oda Yönetimi alanından oda tiplerini oluşturun ve oda numaralarını eksiksiz ekleyin.\n\n2. Personel ve Departman Yetkilendirme:\n• Yönetim > Departman Yönetimi kısmından departmanları ve yetkileri belirleyin.\n• Yönetim > Personel Yönetimi üzerinden çalışanları sisteme kaydedip ilgili departman ve rollere atayın.\n• Personel > Vardiya Planlama ile haftalık vardiya çizelgelerini oluşturun.\n\n3. Rezervasyon ve Ön Büro Süreci:\n• Rezervasyon Takvimi üzerinden doğrudan oda seçerek yeni rezervasyon oluşturun.\n• Misafir geldiğinde Check-In işlemini başlatın ve kimlik/KBS bildirimini tamamlayın.\n• Misafir ayrılırken Check-Out ekranında oda ücreti ve folyoya yansıyan tüm ek harcamaları tek faturada tahsil edin.\n\n4. Restoran & POS Satış İşleyişi:\n• Yönetim > Menü Yönetimi altından kategori ve ürünleri (Yiyecek, İçecek vb.) fiyatlarıyla tanımlayın.\n• Restoran POS ekranında masa açarak sipariş alın; tahsilatı nakit/kart yapabilir veya doğrudan 'Odaya Yaz (Folyo)' seçeneği ile misafirin oda hesabına aktarabilirsiniz.\n\n5. Housekeeping (Kat Hizmetleri) & Oda Bakım:\n• Kat Hizmetleri ekranından kirli, temiz ve arızalı oda durumlarını canlı takip edin.\n• Kat personeline temizlik görevleri atayın ve minibar tüketimlerini folyoya işleyin.\n• Tespit edilen teknik arızaları anında Bakım & Onarım (Maintenance) modülüne iletin."
        ),
        Pair(
            "Rezervasyon Sistemi",
            "Yeni rezervasyon eklemek için sol menüden 'Booking' (Rezervasyon Takvimi) veya Oda Yönetimi ekranlarını kullanabilirsiniz. Müşteri bilgilerini ve tarihlerini seçip kaydedebilirsiniz."
        ),
        Pair(
            "Toplu Fiyatlandırma (CSV İçe Aktarma)",
            "Dinamik Fiyatlandırma (Pricing) ekranında sağ üstteki 'CSV Aktar' butonuna tıklayarak toplu sezon fiyatlarını girebilirsiniz.\n\nCSV Şablonu (Örnek):\nStandart Oda, Yüksek Sezon, 2026-06-01, 2026-09-30, 250.0\n\nSütunlar: Oda Tipi, Sezon Adı, Başlangıç Tarihi, Bitiş Tarihi, Fiyat şeklindedir."
        ),
        Pair(
            "Check-In ve Check-Out İşlemleri",
            "Kullanımdaki Odalar ekranından veya Rezervasyon Takvimi üzerinden Check-In yapabilirsiniz. Check-Out yaparken ise oda ücretine ek olarak Minibar ve POS harcamalarınız otomatik olarak ekrana gelir, isterseniz manuel ekstra ücret (Folyo) ekleyebilirsiniz."
        ),
        Pair(
            "Restoran POS & Minibar (Folio)",
            "Misafirlerin otel içerisindeki (Restoran, Bar vs.) harcamaları POS menüsünden veya Housekeeping menüsünden direkt olarak odaya (Folyo) yazılabilir. Bu harcamalar müşteri çıkış yaparken genel toplama dahil edilir."
        ),
        Pair(
            "Acenta ve Kontenjan Yönetimi",
            "Sistem Yönetimi (Admin) altından acentalarınızı tanımlayabilir ve bu acentalara belirli tarih aralıklarında toplu kontenjan (Allotment) atayabilirsiniz."
        )
    )

    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(Color(0xFFF8FAFC))
            .padding(24.dp)
    ) {
        Text(
            text = "Yardım Merkezi",
            fontSize = 24.sp,
            fontWeight = FontWeight.Bold,
            color = Color(0xFF0F172A),
            modifier = Modifier.padding(bottom = 6.dp)
        )
        
        Text(
            text = "Sıkça Sorulan Sorular ve Kullanım Kılavuzu",
            fontSize = 14.sp,
            color = Color(0xFF64748B),
            modifier = Modifier.padding(bottom = 16.dp)
        )

        // Contact Support Box
        val uriHandler = androidx.compose.ui.platform.LocalUriHandler.current
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .shadow(4.dp, RoundedCornerShape(16.dp), spotColor = Color(0xFF94A3B8).copy(alpha = 0.3f), ambientColor = Color(0xFF94A3B8).copy(alpha = 0.1f))
                .clip(RoundedCornerShape(16.dp))
                .background(Color.White)
                .clickable {
                    try { uriHandler.openUri("mailto:mga@mgacreative.com") } catch (_: Exception) {}
                }
                .padding(18.dp)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Column(modifier = Modifier.weight(1f)) {
                    Text(
                        text = "Doğrudan Destek & İletişim",
                        fontWeight = FontWeight.Bold,
                        fontSize = 15.sp,
                        color = Color(0xFF0F172A)
                    )
                    Spacer(modifier = Modifier.height(2.dp))
                    Text(
                        text = "Sorularınız ve teknik yardım için e-posta gönderin",
                        fontSize = 13.sp,
                        color = Color(0xFF64748B)
                    )
                }
                Text(
                    text = "mga@mgacreative.com",
                    fontWeight = FontWeight.SemiBold,
                    fontSize = 14.sp,
                    color = Color(0xFF2563EB)
                )
            }
        }

        Spacer(modifier = Modifier.height(20.dp))

        val listState = androidx.compose.foundation.lazy.rememberLazyListState()
        LazyColumn(
            state = listState,
            modifier = Modifier.fillMaxSize().verticalScrollbar(listState),
            verticalArrangement = Arrangement.spacedBy(14.dp)
        ) {
            items(helpTopics.size) { index ->
                ExpandableHelpItem(
                    title = helpTopics[index].first,
                    content = helpTopics[index].second
                )
            }
        }
    }
}

@Composable
fun ExpandableHelpItem(title: String, content: String) {
    var expanded by remember { mutableStateOf(false) }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .shadow(6.dp, RoundedCornerShape(16.dp), spotColor = Color(0xFF94A3B8).copy(alpha = 0.4f), ambientColor = Color(0xFF94A3B8).copy(alpha = 0.15f))
            .clip(RoundedCornerShape(16.dp))
            .background(Color.White)
            .clickable { expanded = !expanded }
            .padding(20.dp)
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = title,
                    fontWeight = FontWeight.Bold,
                    fontSize = 16.sp,
                    color = Color(0xFF0F172A),
                    modifier = Modifier.weight(1f)
                )
                Icon(
                    imageVector = if (expanded) Icons.Default.KeyboardArrowUp else Icons.Default.KeyboardArrowDown,
                    contentDescription = if (expanded) "Daralt" else "Genişlet",
                    tint = Color(0xFF64748B)
                )
            }
            
            AnimatedVisibility(visible = expanded) {
                Column(modifier = Modifier.padding(top = 14.dp)) {
                    HorizontalDivider(color = Color(0xFFF1F5F9), modifier = Modifier.padding(bottom = 12.dp))
                    Text(
                        text = content,
                        fontSize = 14.sp,
                        color = Color(0xFF334155),
                        lineHeight = 22.sp
                    )
                }
            }
        }
    }
}

